<h3>Nieuwe Orcaan toevoegen</h3>
<p>Je kunt ook een csv met nieuwe leden naar de WebCie sturen om zo sneller veel leden toe te voegen.</p>
<h4>Basisgegevens</h4>
<form>
  <!--Naam rij-->
  <div fxLayout="row" fxLayoutAlign="start start" class="form-row">
    <!--Voornaam-->
    <mat-form-field fxFlex="30%">
      <mat-label>Voornaam*</mat-label>
      <input matInput name="firstname" [(ngModel)]="member.firstName">
    </mat-form-field>
    <!--Tussenvoegsel-->

    <mat-form-field fxFlex="20%">
      <mat-label>Tussenvoegsel</mat-label>
      <input matInput name="infix" [(ngModel)]="member.infix">
    </mat-form-field>
    <!--Achternaam-->

    <mat-form-field fxFlex="30%">
      <mat-label>Achternaam*</mat-label>
      <input matInput name="lastName" [(ngModel)]="member.lastName">
    </mat-form-field>
    <!--Initialen-->

    <mat-form-field fxFlex="20%">
      <mat-label>Initialen*</mat-label>
      <input matInput name="intitials" [(ngModel)]="member.initials">
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start start" class="form-row">
    <mat-form-field>
      <mat-label>Email*</mat-label>
      <input matInput type="email" name="email" [(ngModel)]="member.email">
    </mat-form-field>

    <mat-form-field>
      <mat-label>Telefoonnummer*</mat-label>
      <input matInput type="text" name="phoneNumber" [(ngModel)]="member.telephoneNumber">
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start start" class="form-row">
    <!--Studie-->
    <mat-form-field fxFlex="40%">
      <mat-label>Studie*</mat-label>
      <input matInput name="study" [(ngModel)]="member.study">
    </mat-form-field>
    <!--studentnummer-->
    <mat-form-field fxFlex="30%">
      <mat-label>Studentnummer* (mag niet 0 zijn)</mat-label>
      <input matInput type="number" name="studentNumber" [(ngModel)]="member.studentNumber">
    </mat-form-field>
    <!-- Instituut -->
    <mat-form-field fxFlex="30%">
      <mat-label>Naam instituut studie* (Bijv. UU, HKU, HU, ...)</mat-label>
      <input matInput name="studyInstitution" [(ngModel)]="member.studyInstitution">
    </mat-form-field>
  </div>


  <div fxLayout="row" fxLayoutAlign="start start" class="form-row">
    <!--Geboortedatum-->
    <mat-form-field fxFlex="50%">
      <mat-label>Geboortedatum*</mat-label>
      <input matInput [matDatepicker]="birthday" name="birthdate" [(ngModel)]="member.birthdate">
      <mat-datepicker-toggle matSuffix [for]="birthday"></mat-datepicker-toggle>
      <mat-datepicker #birthday></mat-datepicker>
    </mat-form-field>
    <!--Geslacht-->
    <mat-form-field fxFlex="50%">
      <mat-label>Geslacht*</mat-label>
      <mat-select [(ngModel)]="member.sexID" name="sexid">
        @for (type of sexTypes; track type) {
          <mat-option [value]="type.typeID">
            {{ type.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start start" class="form-row">
    <!--Lid Status-->
    <mat-form-field fxFlex="50%">
      <mat-label>Status*</mat-label>
      <mat-select [(ngModel)]="member.memberStatusID" name="memberstatusid">
        @for (type of memberStatuses; track type) {
          <mat-option [value]="type.typeID">
            {{ type.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <!--Lid Sinds-->
    <mat-form-field fxFlex="50%">
      <mat-label>Lid sinds*</mat-label>
      <input matInput [matDatepicker]="memberSince" name="memberSince" [(ngModel)]="member.memberSince">
      <mat-datepicker-toggle matSuffix [for]="memberSince"></mat-datepicker-toggle>
      <mat-datepicker #memberSince></mat-datepicker>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start start" class="form-row">
    <mat-form-field fxFlex="100%">
      <mat-label>IBAN*</mat-label>
      <input matInput name="iban" [(ngModel)]="member.iban">
    </mat-form-field>
  </div>

  <!--HUIDIG ADRES-->
  <h4>Huidig adres</h4>
  <div fxLayout="row" fxLayoutAlign="start start" class="form-row">
    <!--Straatnaam-->

    <mat-form-field fxFlex="75%">
      <mat-label>Straatnaam</mat-label>
      <input matInput name="streetname" [(ngModel)]="member.street">
    </mat-form-field>
    <!--Huisnummer-->

    <mat-form-field fxFlex="25%">
      <mat-label>Huisnummer</mat-label>
      <input matInput name="houseNumber" [(ngModel)]="member.houseNumber">
    </mat-form-field>
    <!--Plaatsnaam-->
  </div>
  <div fxLayout="row" fxLayoutAlign="start start" class="form-row">
    <mat-form-field fxFlex="60%">
      <mat-label>Plaatsnaam</mat-label>
      <input matInput name="city" [(ngModel)]="member.city">
    </mat-form-field>
    <!--Postcode-->

    <mat-form-field fxFlex="40%">
      <mat-label>Postcode</mat-label>
      <input matInput name="postalCode" [(ngModel)]="member.postalCode">
    </mat-form-field>
  </div>

  <!--Ouders ADRES-->
  <h4>Adres ouders</h4>
  <div fxLayout="row" fxLayoutAlign="start start" class="form-row">
    <!--Straatnaam-->

    <mat-form-field fxFlex="75%">
      <mat-label>Straatnaam*</mat-label>
      <input matInput placeholder="" name="streetname" [(ngModel)]="member.parentStreet">
    </mat-form-field>
    <!--Huisnummer-->

    <mat-form-field fxFlex="25">
      <mat-label>Huisnummer*</mat-label>
      <input matInput placeholder="" name="houseNumber" [(ngModel)]="member.parentHouseNumber">
    </mat-form-field>
    <!--Plaatsnaam-->
  </div>
  <div fxLayout="row" fxLayoutAlign="start start" class="form-row">
    <mat-form-field fxFlex="45%">
      <mat-label>Plaatsnaam*</mat-label>
      <input matInput placeholder="" name="city" [(ngModel)]="member.parentCity">
    </mat-form-field>
    <!--Postcode-->

    <mat-form-field fxFlex="25%">
      <mat-label>Postcode*</mat-label>
      <input matInput placeholder="" name="postalCode" [(ngModel)]="member.parentPostalCode">
    </mat-form-field>

    <mat-form-field fxFlex="30%">
      <mat-label>Land</mat-label>
      <input matInput placeholder="" name="country" [(ngModel)]="member.parentCountry">
    </mat-form-field>
  </div>

  <h4>Diploma's</h4>

  <mat-form-field>
    <mat-label>Diploma's</mat-label>
    <mat-select multiple placeholder="" [(ngModel)]="member.certificateIDs" name="certificate">
      @for (cert of possibleCerts; track cert) {
        <mat-option [value]="cert.certificateID">
          {{ cert.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <button mat-raised-button color="primary" (click)="addMemberClicked()">Lid toevoegen</button>

  <!--submit-->
</form>
